import { FC, useEffect, useState } from "react";
import { ChrevonRightIcon } from "../../../components/MenuIcons/ChevrotRight";
import { useNavigate, useParams } from "react-router-dom";
import { usePluginspace } from "../../../hooks/usePluginspace";
import api from "../../../services/api";
import { UserIcon } from "../../../components/MenuIcons/UserIcon";
import { StarIcon } from "../../../components/MenuIcons/StarIcon";
import { GiftIcon } from "../../../components/MenuIcons/GiftIcon";
import { LightIcon } from "../../../components/MenuIcons/LightIcon";
import { GearIcon } from "../../../components/MenuIcons/GearIcon";
import { CardCustomer } from "../../../components/CardCustomer/cardCustomer";
import image from "../../../assets/images/contaCriada.png";
import { Loading } from "../../../components/Loading";
import useAuth from "../../../hooks/useAuth";
import { useAppConfig } from "../../../hooks/useAppConfig";

type Options = {
  icon: string;
  title: string;
  subtitle: string;
  route: string;
};

type Route = {
  name: string;
  options: Options[];
};

const IndexPerfil: FC = () => {
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();
  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  const routes: Route[] = [
    {
      name: "Minha conta",
      options: [
        {
          icon: "user",
          title: "Informações pessoais",
          subtitle: "Confira seus dados cadastrais",
          route: `/${pluginspace_id}/profile/info`,
        },
        {
          icon: "gear",
          title: "Configuração da conta",
          subtitle: "Preferências de contato e privacidade",
          route: `/${pluginspace_id}/profile/privacy`,
        },
        {
          icon: "gear",
          title: "Alterar senha",
          subtitle: "Atualização de senha",
          route: `/${pluginspace_id}/profile/new_password`,
        },
        {
          icon: "light",
          title: "Endereços",
          subtitle: "Endereços cadastrados",
          route: `/${pluginspace_id}/profile/addresses`,
        },
      ],
    },
    {
      name: "Compras",
      options: [
        {
          icon: "gift",
          title: "Meus Pedidos",
          subtitle: "Acompanhe suas compras",
          route: `/${pluginspace_id}/search-order`,
        },
        {
          icon: "star",
          title: "Produtos favoritos",
          subtitle: "Confira sua lista de favoritos",
          route: `/${pluginspace_id}/favorites`,
        },
      ],
    },
  ];

  const [account, setAccount] = useState({
    name: "",
    email: "",
    cpf: "",
  });
  const [loading, setLoading] = useState(false);
  const { getToken } = usePluginspace();
  const { loginInfo } = useAuth();

  const getCustomerAndConfig = async () => {
    if (loginInfo.id) {
      setLoading(true);
      try {
        const conf = await getAppConfig();
        if (conf?.webappcolor?.webappbutton) {
          setPrimaryColor(conf.webappcolor.webappbutton);
        }

        await api
          .post(
            `/api/customer/filter`,
            { cpf: loginInfo.identifier },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            },
          )
          .then((response: any) => {
            setLoading(false);
            if (response.data.data.length > 0) {
              const data = response.data.data[0];
              setAccount({
                name: data.name,
                email: data.email,
                cpf: data.doc,
              });
            }
          })
          .catch((err: any) => {
            setLoading(false);
            console.log(err);
          });
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
  };

  const returnIcon = (value: string) => {
    switch (value) {
      case "user":
        return <UserIcon />;
      case "gear":
        return <GearIcon />;
      case "light":
        return <LightIcon />;
      case "star":
        return <StarIcon />;
      case "gift":
        return <GiftIcon />;
      default:
        return null;
    }
  };

  useEffect(() => {
    getCustomerAndConfig();
  }, [loginInfo]);

  return (
    <>
      {loading ? (
        <div className="loading-container" style={{ backgroundColor: "#FFF" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="conteudoPerfil">
          <div className="perfil-success-image">
            <img src={image} alt="Conta" />
          </div>

          <div className="perfil-card-user">
            <CardCustomer
              name={account.name}
              email={account.email}
              cpf={account.cpf}
              show={true}
            />
          </div>

          <div className="perfil-info-geral">
            {routes.map((opc, index) => (
              <div className="perfil-card-option" key={index}>
                <h3 className="perfil-info-name">{opc.name}</h3>

                <div className="perfil-settings-list">
                  {opc.options.map((option, idx) => (
                    <div
                      className="perfil-settings-item"
                      key={idx}
                      onClick={() => navigate(option.route)}
                    >
                      {/* Ícone isolado */}
                      <div
                        className="perfil-item-icon"
                        style={{ color: primaryColor }}
                      >
                        {returnIcon(option.icon)}
                      </div>

                      {/* Textos isolados */}
                      <div className="perfil-item-texts">
                        <h4>{option.title}</h4>
                        <span>{option.subtitle}</span>
                      </div>

                      <div className="perfil-item-arrow">
                        <ChrevonRightIcon action={() => {}} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export { IndexPerfil };
